import React from "react";
import { BtnSearch } from "../tools/BtnSearch";
import { CcV4Toggle } from "../UI/CcV4Toggle";
import { REPORTS_MANAGER_SEARCH_PLACEHOLDER } from "../../utils/reportManagerFilterUtils";

export function ReportsManagerFilterBar({
  search,
  onSearchChange,
  showMineOnly,
  onShowMineOnlyChange,
  className = "",
}) {
  return (
    <div className={`reports-manager-filter-bar${className ? ` ${className}` : ""}`}>
      <CcV4Toggle
        active={showMineOnly}
        label="Мои"
        onClick={() => onShowMineOnlyChange?.(!showMineOnly)}
      />
      <BtnSearch
        placeholder={REPORTS_MANAGER_SEARCH_PLACEHOLDER}
        value={search}
        onChange={onSearchChange}
        className="reports-search-input site-form-control"
      />
    </div>
  );
}
